import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  ManyToOne,
  OneToMany,
  JoinColumn,
  CreateDateColumn,
  UpdateDateColumn,
  PrimaryColumn,
} from 'typeorm';

import {
  MonitoringStatus,
  MonitoringAttachmentsStatus,
} from '../../interface/monitorings/monitorings-response.interface';

import { CompanyEntity } from '../companies/company.entity';
import { ProposalsEntity } from '../proposals/proposals.entity';
import { UsersEntity } from '../users/user.entity';

import { Brand, Industry, ProductCategory } from '../../utils/enums.utils';
import { AttachmentsEntity } from '../attachments/attachments.entity';

@Entity('monitorings')
export class MonitoringsEntity {
  @PrimaryGeneratedColumn('uuid')
  id!: string;

  @Column({ type: 'varchar' })
  status!: MonitoringStatus;

  @Column()
  category!: string;

  @Column({ type: 'text', nullable: true })
  monitoring_remarks?: string | null;

  @Column({ type: 'decimal', precision: 15, scale: 2, nullable: true })
  buying_amount_vat_inc?: number | null;

  @Column({ type: 'decimal', precision: 15, scale: 2, nullable: true })
  selling_amount_vat_inc?: number | null;

  @Column({ type: 'decimal', precision: 15, scale: 2, nullable: true })
  estimated_gross_profit?: number | null;

  @Column({ type: 'decimal', precision: 15, scale: 2, nullable: true })
  mark_up?: number | null;

  @Column({ type: 'decimal', precision: 15, scale: 2, nullable: true })
  selling_amount_vat_ex?: number | null;

  @Column({ type: 'varchar', nullable: true })
  project_code?: string | null;

  @Column({ type: 'varchar' })
  industry!: Industry;

  @Column({ type: 'varchar' })
  product_category!: ProductCategory;

  @Column({ type: 'varchar' })
  brand!: Brand;

  @Column({ type: 'varchar', nullable: true })
  project_name?: string | null;

  @CreateDateColumn()
  created_at!: Date;

  @UpdateDateColumn()
  updated_at!: Date;

  // Relations

  @ManyToOne(() => ProposalsEntity, { nullable: false })
  @JoinColumn({ name: 'proposal_id' })
  proposal!: ProposalsEntity;

  @ManyToOne(() => CompanyEntity, { nullable: false })
  @JoinColumn({ name: 'company_id' })
  company!: CompanyEntity;

  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'created_by_id' })
  created_by?: UsersEntity | null;

  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'updated_by_id' })
  updated_by?: UsersEntity | null;

  // 🔹 Monitoring Attachments
  @OneToMany(() => MonitoringAttachmentsEntity, attachment => attachment.monitoring, {
    cascade: true,
  })
  attachments?: MonitoringAttachmentsEntity[];
}

@Entity('monitoring_attachments')
export class MonitoringAttachmentsEntity {
  // Foreign key column for MonitoringsEntity
  @PrimaryColumn('uuid', { name: 'monitoring_id' })
  monitoring_id!: string;

  @ManyToOne(() => MonitoringsEntity, monitoring => monitoring.attachments, {
    nullable: false,
    onDelete: 'CASCADE',
  })
  @JoinColumn({ name: 'monitoring_id' })
  monitoring!: MonitoringsEntity;

  // Foreign key column for AttachmentsEntity
  @PrimaryColumn('uuid', { name: 'attachment_id' })
  attachment_id!: string;

  @ManyToOne(() => AttachmentsEntity, { nullable: false })
  @JoinColumn({ name: 'attachment_id' })
  attachment!: AttachmentsEntity;

  @Column({ type: 'varchar' })
  status!: MonitoringAttachmentsStatus;
}